import { QuestionAttachment } from "../question-attachment";
import { QuestionAnswer } from "../question-answer";
import { BasicAction } from "./basic-action";

export class AuditResultQuestion {
    public QuestionID: number;
    public AuditResultID: number;
    public AuditResultDetailID: number = -1;
    public QuestionTypeID: number;
    public QuestionHeader: string;
    public QuestionBody: string;
    public QuestionResult: string;
    public QuestionComments: string;
    public Score: number;
    public MaxScore: number;
    public Actions: BasicAction[];
    public QuestionAttachments: QuestionAttachment[];
    public Photos: string[];
    public QuestionAnswers: QuestionAnswer[] = [];
    public ResultValue: string = '';
    public SelectedAnswerID: number = -1;
    public SelectedAnswerIDs: number[] = [];
    public ComplianceLimit: number = -1;
    public AllowNA: boolean = false;
    public NASelected: boolean = false;
    public QuestionAnswered: boolean = false;
    public ExcludeScoreFromTotal: boolean = false;
    public ReferenceQuestion: string = "";
    public ReferenceAnswer: string = "";
    constructor(values: Object = {}) {
        Object.assign(this, values);
        if (values.hasOwnProperty('Actions')) {
            this.Actions = [];
            ((values as AuditResultQuestion)['Actions'] as BasicAction[]).forEach(element => {
                this.Actions.push(new BasicAction(element));
            });
        }
        if (values.hasOwnProperty('QuestionAttachments')) {
            this.QuestionAttachments = [];
            ((values as AuditResultQuestion)['QuestionAttachments'] as QuestionAttachment[]).forEach(element => {
                this.QuestionAttachments.push(new QuestionAttachment(element));
            });
        }
        if (values.hasOwnProperty('QuestionAnswers')) {
            this.QuestionAnswers = [];
            ((values as AuditResultQuestion)['QuestionAnswers'] as QuestionAnswer[]).forEach(element => {
                this.QuestionAnswers.push(new QuestionAnswer(element));
            });
        }
        if (values.hasOwnProperty('SelectedAnswerIDs')) {
            this.SelectedAnswerIDs = [];
            ((values as AuditResultQuestion)['SelectedAnswerIDs'] as number[]).forEach(element => {
                this.SelectedAnswerIDs.push(element);
            });
        }
    }
}
